import { createSelector } from '@ngrx/store'

export const getSearchStreetsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchStreets'),
)

export const getSearchGisStreetsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchGisStreets'),
)

export const getSearchCommunitiesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchCommunities'),
)

export const getSearchContactTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchContactTypes'),
)

export const getSearchContactTitlesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchContactTitles'),
)

export const getSearchPaymentPurposesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchPaymentPurposes'),
)

export const getSearchOrganizationsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchOrganizations'),
)

export const getSearchIndustriesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchIndustries'),
)

export const getSearchFinancialInstitutionsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchFinancialInstitutions'),
)

export const getSwitchableDataCyclesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['switchableDataCycles', 'data']).toJS(),
)

export const getRoundFactorsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['roundFactors', 'data']).toJS(),
)

export const getAreaRoundingState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['areaRounding', 'data']).toJS(),
)

export const getSearchWardsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('searchWards'),
)

export const isWardDetectionLoading = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['detectWardByCoordinate', 'isLoading']),
)

export const getWardDetectionState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['detectWardByCoordinate', 'data']),
)

export const getSearchTypes = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['searchTypes', 'data']).toJS(),
)

export const getWardsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('wards'),
)

export const getDiscountGroupsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['discountGroups', 'data']),
)

export const getAssessableTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['assessableTypes', 'data']),
)

export const getPropertyStatusesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['propertyStatuses', 'data']),
)

export const getBusinessSubcategoryTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['businessSubcategoryTypes', 'data']).toJS(),
)

export const getBusinessSubcategoryCalculationTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) =>
    state.getIn(['businessSubcategoryCalculationTypes', 'data']).toJS(),
)

export const isListDataExportLoading = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['exportListData', 'isLoading']),
)

export const getActiveLayers = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['activeLayers', 'data']),
)

export const getDetectedLayer = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('detectLayer'),
)

export const getDetectedLayers = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('detectAllLayers'),
)

export const getOrganizationsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('organizations'),
)

export const getBusinessCategoriesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('businessCategories'),
)

export const getContactsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('contacts'),
)

export const getContactTitlesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('contactTitles'),
)

export const getFormsState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('forms'),
)

export const getLayerFeaturesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('layerFeatures'),
)

export const getStaticTemplateState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('staticTemplate'),
)

export const getAcceptTermsOfServiceState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.get('acceptTermsOfService'),
)

export const getMobileTaskTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['mobileTaskTypes', 'data']),
)

export const getTemplateTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['templateTypes', 'data']),
)

export const getAuditLogTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['auditLogTypes', 'data']),
)

export const getPropertyTypesByCodeState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['propertyTypesByCode', 'data']),
)

export const getLicenseTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['licenseTypes', 'data']),
)

export const getPropertyTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['propertyTypes', 'data']),
)

export const getMobileUserModesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['mobileUserModes', 'data']),
)

export const getPostprocessorSlotTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['postprocessorSlotTypes', 'data']),
)

export const getDocumentTypesState = createSelector(
  (state: any) => state.shared,
  (state: any) => state.getIn(['documentTypes', 'data']),
)
